export enum usStateCode {
  AL = 'AL',
  AK = 'AK',
  AE = 'AE',
  AA = 'AA',
  AP = 'AP',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  DC = 'DC',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY'
}

export const usStateCodeToNameMap = {
  [usStateCode.AL]: 'Alabama',
  [usStateCode.AK]: 'Alaska',
  [usStateCode.AE]: 'APO/F PO (ZIP 090xx - 098xx)',
  [usStateCode.AA]: 'APO/F PO (ZIP 340xx)',
  [usStateCode.AP]: 'APO/F PO (ZIP 962xx - 966xx)',
  [usStateCode.AZ]: 'Arizona',
  [usStateCode.AR]: 'Arkansas',
  [usStateCode.CA]: 'California',
  [usStateCode.CO]: 'Colorado',
  [usStateCode.CT]: 'Connecticut',
  [usStateCode.DE]: 'Delaware',
  [usStateCode.DC]: 'District of Columbia',
  [usStateCode.FL]: 'Florida',
  [usStateCode.GA]: 'Georgia',
  [usStateCode.HI]: 'Hawaii',
  [usStateCode.ID]: 'Idaho',
  [usStateCode.IL]: 'Illinois',
  [usStateCode.IN]: 'Indiana',
  [usStateCode.IA]: 'Iowa',
  [usStateCode.KS]: 'Kansas',
  [usStateCode.KY]: 'Kentucky',
  [usStateCode.LA]: 'Louisiana',
  [usStateCode.ME]: 'Maine',
  [usStateCode.MD]: 'Maryland',
  [usStateCode.MA]: 'Massachusetts',
  [usStateCode.MI]: 'Michigan',
  [usStateCode.MN]: 'Minnesota',
  [usStateCode.MS]: 'Mississippi',
  [usStateCode.MO]: 'Missouri',
  [usStateCode.MT]: 'Montana',
  [usStateCode.NE]: 'Nebraska',
  [usStateCode.NV]: 'Nevada',
  [usStateCode.NH]: 'New Hampshire',
  [usStateCode.NJ]: 'New Jersey',
  [usStateCode.NM]: 'New Mexico',
  [usStateCode.NY]: 'New York',
  [usStateCode.NC]: 'North Carolina',
  [usStateCode.ND]: 'North Dakota',
  [usStateCode.OH]: 'Ohio',
  [usStateCode.OK]: 'Oklahoma',
  [usStateCode.OR]: 'Oregon',
  [usStateCode.PA]: 'Pennsylvania',
  [usStateCode.RI]: 'Rhode Island',
  [usStateCode.SC]: 'South Carolina',
  [usStateCode.SD]: 'South Dakota',
  [usStateCode.TN]: 'Tennessee',
  [usStateCode.TX]: 'Texas',
  [usStateCode.UT]: 'Utah',
  [usStateCode.VT]: 'Vermont',
  [usStateCode.VA]: 'Virginia',
  [usStateCode.WA]: 'Washington',
  [usStateCode.WV]: 'West Virginia',
  [usStateCode.WI]: 'Wisconsin',
  [usStateCode.WY]: 'Wyoming'
}

export const usStates = [
  { value: usStateCode.AL, label: usStateCodeToNameMap.AL },
  { value: usStateCode.AK, label: usStateCodeToNameMap.AK },
  { value: usStateCode.AE, label: usStateCodeToNameMap.AE },
  { value: usStateCode.AA, label: usStateCodeToNameMap.AA },
  { value: usStateCode.AP, label: usStateCodeToNameMap.AP },
  { value: usStateCode.AZ, label: usStateCodeToNameMap.AZ },
  { value: usStateCode.AR, label: usStateCodeToNameMap.AR },
  { value: usStateCode.CA, label: usStateCodeToNameMap.CA },
  { value: usStateCode.CO, label: usStateCodeToNameMap.CO },
  { value: usStateCode.CT, label: usStateCodeToNameMap.CT },
  { value: usStateCode.DE, label: usStateCodeToNameMap.DE },
  { value: usStateCode.DC, label: usStateCodeToNameMap.DC },
  { value: usStateCode.FL, label: usStateCodeToNameMap.FL },
  { value: usStateCode.GA, label: usStateCodeToNameMap.GA },
  { value: usStateCode.HI, label: usStateCodeToNameMap.HI },
  { value: usStateCode.ID, label: usStateCodeToNameMap.ID },
  { value: usStateCode.IL, label: usStateCodeToNameMap.IL },
  { value: usStateCode.IN, label: usStateCodeToNameMap.IN },
  { value: usStateCode.IA, label: usStateCodeToNameMap.IA },
  { value: usStateCode.KS, label: usStateCodeToNameMap.KS },
  { value: usStateCode.KY, label: usStateCodeToNameMap.KY },
  { value: usStateCode.LA, label: usStateCodeToNameMap.LA },
  { value: usStateCode.ME, label: usStateCodeToNameMap.ME },
  { value: usStateCode.MD, label: usStateCodeToNameMap.MD },
  { value: usStateCode.MA, label: usStateCodeToNameMap.MA },
  { value: usStateCode.MI, label: usStateCodeToNameMap.MI },
  { value: usStateCode.MN, label: usStateCodeToNameMap.MN },
  { value: usStateCode.MS, label: usStateCodeToNameMap.MS },
  { value: usStateCode.MO, label: usStateCodeToNameMap.MO },
  { value: usStateCode.MT, label: usStateCodeToNameMap.MT },
  { value: usStateCode.NE, label: usStateCodeToNameMap.NE },
  { value: usStateCode.NV, label: usStateCodeToNameMap.NV },
  { value: usStateCode.NH, label: usStateCodeToNameMap.NH },
  { value: usStateCode.NJ, label: usStateCodeToNameMap.NJ },
  { value: usStateCode.NM, label: usStateCodeToNameMap.NM },
  { value: usStateCode.NY, label: usStateCodeToNameMap.NY },
  { value: usStateCode.NC, label: usStateCodeToNameMap.NC },
  { value: usStateCode.ND, label: usStateCodeToNameMap.ND },
  { value: usStateCode.OH, label: usStateCodeToNameMap.OH },
  { value: usStateCode.OK, label: usStateCodeToNameMap.OK },
  { value: usStateCode.OR, label: usStateCodeToNameMap.OR },
  { value: usStateCode.PA, label: usStateCodeToNameMap.PA },
  { value: usStateCode.RI, label: usStateCodeToNameMap.RI },
  { value: usStateCode.SC, label: usStateCodeToNameMap.SC },
  { value: usStateCode.SD, label: usStateCodeToNameMap.SD },
  { value: usStateCode.TN, label: usStateCodeToNameMap.TN },
  { value: usStateCode.TX, label: usStateCodeToNameMap.TX },
  { value: usStateCode.UT, label: usStateCodeToNameMap.UT },
  { value: usStateCode.VT, label: usStateCodeToNameMap.VT },
  { value: usStateCode.VA, label: usStateCodeToNameMap.VA },
  { value: usStateCode.WA, label: usStateCodeToNameMap.WA },
  { value: usStateCode.WV, label: usStateCodeToNameMap.WV },
  { value: usStateCode.WI, label: usStateCodeToNameMap.WI },
  { value: usStateCode.WY, label: usStateCodeToNameMap.WY }
]
